import React from 'react'
import { Stack } from "@mui/material"
import dayjs from 'dayjs'
import { StyledLeaderTableCell, StyledWorkRangeBar, StyledWorkRangeBox } from '../../../styles/LeaderCalendarTableStyles'
import { WeeklyCalendarTooltip } from './WeeklyCalendarTooltip'
import { calculateMenteeBar } from '../../../store/utils/calculateMenteeBar'
import { Mentee } from '../../../store/types/response/LeaderMenteesPlanResponse'

type DailyBarProps = {
  selectedDate: string,
  hour: string,
  mentee: Mentee,
  isWidened?: boolean 
}

export const DailyBar = ({
  selectedDate,
  hour,
  mentee,
  isWidened = false
}: DailyBarProps) => {
  const day = new Date(selectedDate).toISOString().split("T")[0]
  const isWeekend = dayjs(selectedDate).day() === 0 || dayjs(selectedDate).day() === 6
  const workDay = mentee.workSchedule.find((s) => s.date === day)
  const foundShift = workDay?.shifts?.find((shift) => shift.from.startsWith(hour.slice(0, 2)))

  const isStartWorkingTimeRange = !!foundShift

  const startHour = foundShift?.from.slice(0, 5) || '0:00'
  const endHour = foundShift?.to.slice(0, 5) || '24:00'

  const isStartVacationTimeRange = workDay?.isVacation ? workDay?.isVacation && hour === '00:00' : false
  const { height, padding } = isStartWorkingTimeRange || isStartVacationTimeRange ? calculateMenteeBar(hour, startHour, endHour, isStartVacationTimeRange) : { height: '0px', padding: '0px' }

  return (
    <StyledLeaderTableCell
      key={`${mentee.id}-${hour}`}
      sx={{
        backgroundColor: isWeekend ? 'background.elevation2' : '',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          flexDirection: 'row',
          justifyContent: 'center',
          gap: '2px',
          px: isWidened ? '15px' : 0
        }}
      >
        {(isStartWorkingTimeRange || isStartVacationTimeRange) ? (
          <WeeklyCalendarTooltip
            mentee={`${mentee.firstName} ${mentee.lastName}`}
            day={day}
            hour={`${startHour} - ${endHour}`}
            isWorkingRangeTooltip={isStartWorkingTimeRange}
          >
            <StyledWorkRangeBox sx={{ maxWidth: isWidened ? '100%' : '160px' }} paddingTop={padding}>
              <StyledWorkRangeBar
                sx={{ maxWidth: '100%' }}
                isWorkingTimeBar={isStartWorkingTimeRange}
                height={height}
              >
              </StyledWorkRangeBar>
            </StyledWorkRangeBox>
          </WeeklyCalendarTooltip>
        ) : (
          <StyledWorkRangeBox />
        )}
      </Stack>
    </StyledLeaderTableCell>
  )
}